module.exports = __webpack_public_path__ + "img/mission_claim_panel.361320fb.png";